/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
  var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
  if (api && typeof api.t === 'function') return api.t(key, params);
  if (typeof module === 'object' && module.exports && typeof require === 'function') {
    var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
    var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
    var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
    return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
  }
  return key;
}

(function () {
    'use strict';

    var ns = globalThis.PewniakiStatV2 = globalThis.PewniakiStatV2 || {};

    var BOM = '\uFEFF';

    // Excel traktuje pola zaczynajace sie od = + - @ jako formule, a wiodacy
    // tab/CR/LF potrafi rozjechac parser — w obu razach dajemy apostrof.
    function zabezpiecz(pole) {
        var i = 0;
        while (i < pole.length) {
            var z = pole.charAt(i);
            if (z === ' ' || z === '\t' || z === '\r' || z === '\n') {
                i += 1;
                continue;
            }
            break;
        }
        var pierwszy = pole.charAt(0);
        var znaczacy = pole.charAt(i);
        var ryzykowny = znaczacy === '=' || znaczacy === '+' || znaczacy === '-' || znaczacy === '@';
        var biale = pierwszy === '\t' || pierwszy === '\r' || pierwszy === '\n';
        return (ryzykowny || biale) ? "'" + pole : pole;
    }

    function komorka(pole) {
        if (typeof pole !== 'string') {
            throw new TypeError(jst("ui.aec4bf02fa77af9c"));
        }
        return '"' + zabezpiecz(pole).split('"').join('""') + '"';
    }

    function wiersz(pola) {
        if (!Array.isArray(pola)) {
            throw new TypeError(jst("ui.8a28bf74f33482ca"));
        }
        var wyjscie = [];
        for (var i = 0; i < pola.length; i += 1) {
            wyjscie.push(komorka(pola[i]));
        }
        return wyjscie.join(';') + '\r\n';
    }

    ns.csv = function (input) {
        if (!input || typeof input !== 'object') {
            throw new TypeError(jst("ui.cd59d257aa5f5271"));
        }
        if (!Array.isArray(input.naglowki) || !Array.isArray(input.wiersze)) {
            throw new TypeError(jst("ui.1d5f2dfcf3d8bed9"));
        }

        var tekst = BOM + wiersz(input.naglowki);
        for (var i = 0; i < input.wiersze.length; i += 1) {
            tekst += wiersz(input.wiersze[i]);
        }
        return tekst;
    };
}());
